// // Swiper
// import Swiper from 'swiper';

// // GSAP Core + Scrolltrigger
// import { gsap } from 'gsap'
// import ScrollTrigger from 'gsap/ScrollTrigger'
// gsap.registerPlugin(ScrollTrigger);

// Vanilla lazyload : https://github.com/verlok/vanilla-lazyload
import LazyLoad from 'vanilla-lazyload'
new LazyLoad();

// Intersector scriptss
import './custom/bwh-animate-group.js';
import './custom/bwh-animate-element.js';
import './custom/bwh-auto-slide-in.js';

// Util scripts
import './custom/bwh-footer-space.js';
import './custom/hashtag-handle.js';

// Alpine + Alpine-ajax
import Alpine from 'alpinejs'
import alpineAjax from '@imacrayon/alpine-ajax'

window.Alpine = Alpine
window.Alpine.plugin(alpineAjax)

// Load scripts met Alphine
import './components/headroom.js';
import './components/searchpanel.js';
import './components/panel.js';
import './custom/panel-handle.js';
import './components/accordion.js';
import './components/marquee.js';

// Default scripts
import './custom/default-module-filters.js';
import './custom/default-image-carousel.js';
import './custom/video-js-player.js';
import './custom/news-module-carousel.js';
// import './custom/agenda-module-carousel.js';
// import './custom/dropdown-menu.js';
// ..

// Added scripts

// Start Alpine
Alpine.start();